import {Component, ElementRef} from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
})
export class AboutComponent {
  constructor(private elRef: ElementRef) {
  }

  scrollIntoView(): any {
    this.elRef.nativeElement.scrollIntoView();
  }
}
